import { ImageVariationModel } from "./imageVariation";
import { ImageTypeModel } from "./imageType";
import { UUID } from "../generic/uuid";
import { ImageImageTypeCropPropertyModel } from "./imageImageTypeCropProperty";
import { ImageDto } from "@vini-wine/core-dtos";

export interface ImageModel extends UUID {
  // transform
  name: string;
  mime: string;
  height: number;
  width: number;
  url: string;
  variation: ImageVariationModel;
  type: ImageTypeModel;
  size: number;

  // available includes
  originalImage?: ImageModel;
  imageImageTypeCropProperties?: ImageImageTypeCropPropertyModel[];
}

export const createImageDtoFromAdminImageModel = (
  image: ImageModel,
): ImageDto => {
  return {
    name: image.name,
    mime: image.mime,
    height: image.height,
    width: image.width,
    url: image.url,
    variation: {
      id: image.variation.id,
    },
    type: {
      id: image.type.id,
    },
    size: image.size,
  };
};
